import baseConfig, { Config } from "../../utils/config";

// Visual query demo - venetian
const insuremepConfig: Config = {
  ...baseConfig,
  AppName: "CADViewer Visual Query:",
  initFileName: "content/custom/ibaseit.com/Science III/telecom/Standard/EC.02.dwg", //"/content/demo_user/architectural-plan.dwg",
  ServerBackEndUrl: "http://localhost:3000", // "https://server.demo.cadviewer.com", //"http"http://localhost:3000"://localhost:3000", //"https://server.demo.cadviewer.com", //"https://server.demo.cadviewer.com", //"https://cadviewer-conversion-server-webapp-01.azurewebsites.net/", //"http://localhost:3000", //, //"http://localhost:3000", //"https://cadviewer-conversion-server-webapp-01.azurewebsites.net/", //"http://restapi.cadviewer.com:3000/", // "https://cadviewer-conversion-server-webapp-01.azurewebsites.net/", //"http://restapi.cadviewer.com:3000/", //"http://localhost:3000/", //"https://restapi.cadviewer.com:3000/", //"https://cadviewer-conversion-server-webapp-01.azurewebsites.net/", //"https://restapi.cadviewer.com:3000", //"https://cadviewer-conversion-server-webapp-01.azurewebsites.net/" , //"https://127.0.0.1:3000",  //"http://localhost:3000", //"https://cadviewer-conversion-server-webapp-01.azurewebsites.net/", //"http://localhost:3000",          //""http://localhost:3000",  //"https://cadviewer-conversion-server-webapp-01.azurewebsites.net/",           // This is the URL of the CADViewer back-end server
  ServerLocation: "", // leave blank  in most cases
  ServerUrl: "http://localhost:3001", //"http://vizquery.cadviewer.com", //"https://demo.cadviewer.com", //"http://localhost:3001", //"https://demo.cadviewer.com/", // "http:localhost:3001", / this is the URL of the front end server
  DisplayCoordinatesMenu: false, // display the CADViewer coordinates menu
  displayTopNavigationBar: true, // display the layout /model space navigation menu
  setSpaceObjectsCustomMenu: true, // display the SpaceObject Navigation menu
  hideLeftHamburgerMenu: false, // hide the left hamburger menu
  BaseAttributes: {
    fill: "#ffd7f4", //'#D3D300', // '#ffd7f4', // '#FFF' , //  '#D3D300', // #D3D3D3  // #FFF   #ffd7f4
    "fill-opacity": 0.0, // 0.1
    stroke: "#CCC",
    "stroke-width": 0.1,
    "stroke-linejoin": "round",
    "stroke-opacity": 1.0,
  },
  /*  HighlightAttributes: {
      fill: "#a4d7f4",
      "fill-opacity": 0.5,
      stroke: "#a4d7f4",
      "stroke-width": 0.2,
      "stroke-linejoin": "round",
      "stroke-opacity": 1.0,
    },
    SelectAttributes: {
      fill: "#5BBEF6",
      "fill-opacity": 0.5,
      stroke: "#5BBEF6",
      "stroke-width": 0.23,
      "stroke-linejoin": "round",
      "stroke-opacity": 1.0,
    }, */
  HighlightAttributes: {
    fill: '#Ffa500', //'#00F', //'#F4d7f4', //'#a4d7f4',
    "fill-opacity": 0.3,
    stroke: '#7B3804', //'#00F', // '#a4d7f4',
    'stroke-width': 2.5, //0.2,
    'stroke-linejoin': 'round',
    'stroke-opacity': 1.0,
  },
  SelectAttributes: {
    fill: '#F00', //'#5BFEF6', //'#5BBEF6',
    "fill-opacity": 0.3,
    stroke: '#5B0303', //'#5BBEF6',
    'stroke-linejoin': 'round',
    'stroke-width': 4, //0.23,
    'stroke-opacity': 1.0,
  },
  DefaultSpaceObjectAttributes: {   // test
    fill: '#3CB043',
    "fill-opacity": "0.3",      // fill opacity set to 0.1
    stroke: '#234F1E',
    'stroke-linejoin': 'round',
    'stroke-width': "0.2",
    'stroke-opacity': 1.0,
  },
  postFixServerToken: false,
  globalApplicationFilesLocation:
    "http://localhost:3000/content/custom/uic.edu/json/application/",
  propertySVGFilesLocation: "http://localhost:3000/content/custom/uic.edu/svg/",
  propertyJSONFilesLocation:
    "http://localhost:3000/content/custom/uic.edu/json/property/",
  // Default property to Load
  defautlPropertyToLoad: {
    propertyNumber: "", //"2339", // set to undefined to disable default property
    planName: "", //"LP0", // set to undefined to disable default plan
  },
  enableQuickPdfPrint: true,
  chatResultDisplayMetrics: true, // Set to true to display metrics in the chat results
  propertyJSONFilesEnableDistance: true,
  propertyJSONFilesEnableLayerColors: true,
  topPaneScrollDownTitle: "Choose information plan/layer:", // set te title of the top pane scroll down menu
  displayTopPaneScrollDownButton: true, // display the top pane scroll down button, true to show the top pane scroll down menu
  topRowItem1: "Property Name:", // top row items
  topRowItem2: "Property Number:", // top row items
  topRowItem3: "Plan Name:", // top row items
  enableRightJSONModalPanel: false, // enabling JSON load right side pane for property selection
  setCADViewerSkin: "light-skin", //CADViewer Skin lightgray, black, deepblue, light-skin, dark-skin
  showLogoOnSideBarLeftPanel: true, // Set to true to display the logo on the side bar left panel
  debugMode: true, // enables CADViewer debug traces in the browser
  enableHelperMethods: true,
  enableHelpersMethodsGroup_Highlight: false,
  enableHelpersMethodsGroup_Group: false,
  enableHelpersMethodsGroup_Manipulate: false,
  enableHelpersMethodsGroup_Insert: false,
  enableHelpersMethodsGroup_CustomCanvas: false,
  enableHelpersMethodsGroup_SpaceArea: false,
  enableHelpersMethodsGroup_RedlineArea: false,
  enableHelpersMethodsGroup_VizQueryDemo: false,
  enableHelpersMethodsGroup_Brookfield: false,
  enableHelpersMethodsGroup_UrbanEdge: false,
  enableHelpersMethodsGroup_UicEdu: false,
  enableHelpersMethodsGroup_Insuremep: true,



  enableAIChat: true,
  useAIChatV5: true,
  useAIChatV4: false,

  aiChatV2Endpoint: "/ai/v2/chat", // Endpoint for the new AI chat service
  aiChatV3Endpoint: "/ai/v3/search-spaces", // Endpoint for the V3 AI chat service
  aiChatV4Endpoint: "http://localhost:8000/process-query-v4", // Endpoint for the V4 AI chat service
  aiChatV5Endpoint: "http://localhost:3000/ai/proxy", // Endpoint for the V5 proxy (supports snowflake and python)
  aiChatV5Provider: "python" as "snowflake" | "python" | "snowflake-agent", // Provider for the V5 proxy endpoint
  aiChatV5Mode: "Test" as "Test" | "Prod", // Mode for the V5 proxy endpoint (defaults to "Test")


  setBPLayerChange: false, // SET custom HEADER for BP Retail Layer Change  - 10.55.2
  customOnLoadEndContent: false, // custom OnLoadEnd content -processing of custom content in CADViewer.js
  defaultLayerColorsOnLoad: [
    // set the layer colors for BP Retail
    { layer: "0", color: "#000" },
    { layer: "A-FLOR-STRS", color: "#000" },
    { layer: "A-FLOR", color: "#000" },
    { layer: "A-FLOR-EVTR", color: "#000" },
    { layer: "A-WALL", color: "#000" },
    { layer: "A-DOOR", color: "#000" },
  ],

  enableRightEmployeePanel: false,
  enableRightEmployeePanelText: "Employees",
  enableRightArchivePanel: false,
  enableRightArchivePanelText: "Archive",

  enableRightFileModalPanel: true,   // open files enabled
  serverSubFolder: "/custom/ibaseit.com/", // the subfolder where the drawings are located, relative to the server URL,
  showOnlySubFolder: true, // if true, only show the serverSubFolder and its children, hide the rest of the tree


  // VISUAL QUERY PANEL CONTROLS
  ShowInformativeBottomPanel: false, // turn the the bottom panel on off
  ShowInformativeBottomPanelWhenClickInLeftPanel: true,
  ShowInformativeLeftPanel: false, // initia show the left side panel
  bottomPaneSliderMode: "withCADViewer", // withCADViewer, aboveCADViewer,
  bottomPaneDefaultHeight: 15, // (15)   percentage of screen height (2) min
  rightPanelDefaultWidth: 36, // (40) percentage of screen height
  leftPaneDefaultWidth: 17, // (17) percentage of screen height



  popupCustomMenu1: "Custom<br>Method 1<br>", // custom menu 1   -  my_own_clickmenu1 in CADViewer.js
  popupCustomFontAwesomeIcon1: "fa fa-info-circle", // custom menu 1 - icon 1
  popupCustomMenu2: "Custom <br>Method 2<br>", // custom menu 2 - my_own_clickmenu2 in CADViewer.js
  popupCustomFontAwesomeIcon2: "fa fa-undo", // custom menu 2  - icon 2
  cvjs_styleQTip_width: "320px", // set the width of the popup

  popupCustomMenuNoDataSet: "No Data Set Provided for this Object", // custom menu for no data set
  popupCustomMenuNoDataSetIcon: "fa fa-times", // custom menu for no data set icon

  omitSpaceObjectLayerHandling: false
};

export default insuremepConfig;
